import React from 'react'
import './MonthCalendarSkeleton.css'

/**
 * MonthCalendarSkeleton - Loading skeleton for month calendar
 * Displays a placeholder calendar grid while data is loading
 */
function MonthCalendarSkeleton() {
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  // 6 weeks covers the maximum possible weeks in a month (e.g. 31 days starting on Saturday)
  const weeks = Array(6).fill(null)
  const daysPerWeek = Array(7).fill(null)

  return (
    <div
      className="fl__month-calendar-skeleton"
      data-testid="month-calendar-skeleton"
    >
      {/* Header skeleton */}
      <div className="fl__month-skeleton-header">
        <div className="fl__skeleton-nav-button"></div>
        <div className="fl__skeleton-title"></div>
        <div className="fl__skeleton-nav-button"></div>
      </div>

      {/* Legend skeleton */}
      <div className="fl__month-skeleton-legend">
        <div className="fl__skeleton-legend-item"></div>
        <div className="fl__skeleton-legend-item"></div>
        <div className="fl__skeleton-legend-item"></div>
      </div>

      {/* Calendar grid skeleton */}
      <div className="fl__month-skeleton-grid">
        {/* Day names header */}
        <div className="fl__month-skeleton-grid-header">
          {dayNames.map((day) => (
            <div key={day} className="fl__skeleton-day-name">
              {day}
            </div>
          ))}
        </div>

        {/* Week rows */}
        <div className="fl__month-skeleton-grid-body">
          {weeks.map((_, weekIndex) => (
            <div key={weekIndex} className="fl__month-skeleton-week">
              {daysPerWeek.map((_, dayIndex) => (
                <div key={dayIndex} className="fl__skeleton-day-cell">
                  <div className="fl__skeleton-day-number"></div>
                  <div className="fl__skeleton-day-dots">
                    <div className="fl__skeleton-dot"></div>
                    <div className="fl__skeleton-dot"></div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MonthCalendarSkeleton
